<template>
  <div class="seller">
    <el-header class="seller-layout-header"><sellerHeader /></el-header>
    <el-container class="seller-layout-container">
      <el-aside class="seller-layout-left"><sellerLeftNav /></el-aside>
      <el-main class="seller-layout-main"><sellerMain /></el-main>
    </el-container>
  </div>
</template>

<script>
import { sellerHeader, sellerLeftNav, sellerMain } from './component'

export default {
  name: 'seller',
  components: {
    sellerHeader,
    sellerLeftNav,
    sellerMain
  }
}
</script>

<style lang="scss">
.seller {
  position: relative;
}
.seller-layout-container {
  width: 100%;
  height: 100vh;
  padding-top: 60px;
  position: absolute;
  top: 0;
}
.seller-layout-header, .seller-layout-main {
  padding: 0;
}
.seller-layout-header {
  position: relative;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue